import { render, staticRenderFns } from "./baseFormDialog.vue?vue&type=template&id=2154e3c2&scoped=true&"
import script from "./baseFormDialog.vue?vue&type=script&lang=js&"
export * from "./baseFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./baseFormDialog.vue?vue&type=style&index=0&id=2154e3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154e3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2154e3c2')) {
      api.createRecord('2154e3c2', component.options)
    } else {
      api.reload('2154e3c2', component.options)
    }
    module.hot.accept("./baseFormDialog.vue?vue&type=template&id=2154e3c2&scoped=true&", function () {
      api.rerender('2154e3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/baseFormDialog.vue"
export default component.exports